import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getId = (state: RootState) => state.pages.editor.backgrounds.selected;

const getSelectedBackgroundId = createSelector([getId], (id) => id);

export default getSelectedBackgroundId;
